(function () {
  var BANNER_CONTROL_SELECTOR =
    '.slider-button, .slideshow__controls, .custom-slider-navigation, .slick-arrow, .slick-dots, .slick-prev, .slick-next';

  function webengageOnReady(cb) {
    if (typeof webengage === 'undefined' || typeof webengage.onReady !== 'function') {
      setTimeout(function () {
        webengageOnReady(cb);
      }, 100);
      return;
    }
    webengage.onReady(cb);
  }

  function trackWebEngageEvent(eventName, eventData) {
    webengageOnReady(function () {
      webengage.track(eventName, withHttpsImageUrls(eventData));
    });
  }

  function toNumber(value) {
    if (typeof value === 'number' && !isNaN(value)) return value;
    var parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  function toHttpsUrl(url) {
    var value = String(url || '').trim();
    if (!value || value === 'null') return '';
    if (value.indexOf('//') === 0) return 'https:' + value;
    if (value.indexOf('http://') === 0) return 'https://' + value.slice(7);
    return value;
  }

  function withHttpsImageUrls(eventData) {
    if (!eventData || typeof eventData !== 'object') return eventData;
    ['Image', 'Image clicked'].forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(eventData, key)) {
        eventData[key] = toHttpsUrl(eventData[key]);
      }
    });
    return eventData;
  }

  function payloadFromElement(el, includeRating) {
    var payload = {
      'Product ID': String(el.getAttribute('data-we-product-id') || ''),
      'Product Type': el.getAttribute('data-we-product-type') || '',
      Image: el.getAttribute('data-we-image') || '',
      Price: toNumber(el.getAttribute('data-we-price')),
      Title: el.getAttribute('data-we-title') || '',
      'Variant ID': String(el.getAttribute('data-we-variant-id') || ''),
      'Variant Title': el.getAttribute('data-we-variant-title') || '',
    };

    if (includeRating) {
      payload.Rating = toNumber(el.getAttribute('data-we-rating'));
    }

    return payload;
  }

  function payloadFromProductPage(includeRating) {
    var node = document.getElementById('webengage-product-data');
    if (!node) return null;

    var product;
    try {
      product = JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }

    var variantId = '';
    var idInput = document.querySelector('product-info [name="id"]');
    if (idInput && idInput.value) variantId = String(idInput.value);

    var variants = product.variants || [];
    var variant =
      variants.filter(function (item) {
        return String(item.id) === variantId;
      })[0] ||
      variants[0] ||
      {};

    var payload = {
      'Product ID': String(product.id || ''),
      'Product Type': product.type || '',
      Image: variant.image || product.image || '',
      Price: toNumber(variant.price != null ? variant.price : product.price),
      Title: product.title || '',
      'Variant ID': String(variant.id || variantId || ''),
      'Variant Title': variant.title || '',
    };

    if (includeRating) {
      payload.Rating = toNumber(product.rating);
    }

    return payload;
  }

  function getProductPayload(el, includeRating) {
    var pagePayload = payloadFromProductPage(includeRating);
    var hasElementProduct = el && el.getAttribute('data-we-product-id');

    if (hasElementProduct) {
      if (pagePayload && String(pagePayload['Product ID']) === String(el.getAttribute('data-we-product-id'))) {
        return pagePayload;
      }
      return payloadFromElement(el, includeRating);
    }

    return pagePayload || {};
  }

  function getProductImagePayload(el) {
    var payload = getProductPayload(el, false);
    delete payload.Image;
    payload['Image Position'] = String(el.getAttribute('data-we-image-position') || '');
    payload['Image clicked'] = el.getAttribute('data-we-image-clicked') || '';
    return payload;
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest(BANNER_CONTROL_SELECTOR)) return;

    var banner = event.target.closest('[data-we-banner]');
    if (banner) {
      trackWebEngageEvent('Banner Clicked', {
        'Banner Position': banner.getAttribute('data-we-banner-position') || '',
        'Banner ID': banner.getAttribute('data-we-banner-id') || '',
        'Page URL': window.location.href,
      });
      return;
    }

    var productEventEl = event.target.closest('[data-we-event]');
    if (productEventEl) {
      var eventName = productEventEl.getAttribute('data-we-event');
      if (!eventName) return;

      if (eventName === 'Product Image Viewed') {
        trackWebEngageEvent(eventName, getProductImagePayload(productEventEl));
        return;
      }

      trackWebEngageEvent(
        eventName,
        getProductPayload(productEventEl, eventName === 'Review Button Clicked')
      );
    }
  });
})();
